/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Scope_GlobalInputs */



/**
* | output |
* | --- |
* | "Global" |
*
* @param {Community_Scope_GlobalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_scope_global = /** @type {((inputs?: Community_Scope_GlobalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Scope_GlobalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mondial")
	if (locale === "es") return /** @type {LocalizedString} */ ("Global")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Global")
	if (locale === "it") return /** @type {LocalizedString} */ ("Globale")
	return /** @type {LocalizedString} */ ("Global")
});